module.exports = __webpack_public_path__ + "static/media/Gregory.101bf025.png";